export default function Contact() {
  const containerStyle = {
    maxWidth: '600px',
    margin: '0 auto',
    padding: '24px',
    fontFamily: 'Arial, sans-serif',
  };

  const headingStyle = {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '16px',
  };

  const sectionStyle = {
    marginBottom: '24px',
  };

  const subheadingStyle = {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '8px',
  };

  const textStyle = {
    fontSize: '16px',
    color: '#333',
    lineHeight: '1.5',
  };

  return (
    <div style={containerStyle}>
      <h2 style={headingStyle}>Contact Us</h2>

      <div style={sectionStyle}>
        <h3 style={subheadingStyle}>Address</h3>
        <p style={textStyle}>
          24898 Tallman Avenue<br/>
          Warren, MI 48089
        </p>
      </div>

      <div style={sectionStyle}>
        <h3 style={subheadingStyle}>Email</h3>
        <p style={textStyle}>jake.pelter@gmail.com</p>
      </div>

      <div style={sectionStyle}>
        <h3 style={subheadingStyle}>Cell Phone</h3>
        <p style={textStyle}>Jake: +1 (330) 931-1500</p>
      </div>
    </div>
  );
}
